// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OCnL","label":"styles_label__1oYif"};